import {
  ObjectDatasetDataDto,
  ObjectDatasetDataPagedReq,
  ObjectDatasetDataReq,
  ObjectDatasetDto,
  ObjectDatasetReq,
  ObjectDatasetWithDaysDto,
} from "components/dashboard/object-dataset/object-dataset-types";
import { APIResponse } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { PaginatedResponse } from "./model/dashboard/Dashboard";

class ObjectDatasetApiDefinition extends ApiDefinition {
  constructor() {
    super("/object-dataset");
  }

  async getObjectDatasets(companyRef: string): Promise<APIResponse<ObjectDatasetDto[]>> {
    return this.get(companyRef);
  }

  async getObjectDataset(
    identifier: string,
    companyRef: string
  ): Promise<APIResponse<ObjectDatasetWithDaysDto>> {
    return this.get(`${companyRef}/${identifier}`);
  }

  async createObjectDataset(
    objectDataset: ObjectDatasetReq,
    companyRef: string
  ): Promise<APIResponse<ObjectDatasetDto>> {
    return this.post(companyRef, objectDataset);
  }

  async deleteObjectDataset(identifier: string, companyRef: string): Promise<APIResponse<ObjectDatasetDto>> {
    return this.delete(`${companyRef}/${identifier}`);
  }

  async getObjectDatasetDataInRange(req: ObjectDatasetDataReq): Promise<APIResponse<ObjectDatasetDataDto[]>> {
    return this.get(`${req.companyRef}/${req.identifier}/data-by-range`, {
      params: { startDate: req.startDate, endDate: req.endDate },
    });
  }

  async getObjectDatasetDataPagedInRange(
    req: ObjectDatasetDataPagedReq
  ): Promise<APIResponse<PaginatedResponse<ObjectDatasetDataDto>>> {
    return this.get(`${req.companyRef}/${req.identifier}/paged-data-by-range`, {
      params: { startDate: req.startDate, endDate: req.endDate, skip: req.skip, take: req.take },
    });
  }

  async deleteObjectDatasetData(
    identifier: string,
    timestamp: string,
    companyRef: string
  ): Promise<APIResponse<ObjectDatasetDataDto>> {
    return this.delete(`${companyRef}/${identifier}/${timestamp}`);
  }

  async deleteObjectDatasetDataFile(
    identifier: string,
    timestamp: string,
    companyRef: string,
    filePath: string
  ): Promise<APIResponse<ObjectDatasetDataDto>> {
    return this.delete(`${companyRef}/${identifier}/${timestamp}/${filePath}`);
  }
}

const ObjectDatasetApi = new ObjectDatasetApiDefinition();

export default ObjectDatasetApi;
